import script from "./MenuCountChip.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuCountChip.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__